var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbout = function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "1.5 1.5 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 7.08268C11.2501 7.77304 10.6904 8.33268 10.0001 8.33268C9.30973 8.33268 8.75008 7.77304 8.75008 7.08268C8.75008 6.39233 9.30973 5.83268 10.0001 5.83268C10.6904 5.83268 11.2501 6.39233 11.2501 7.08268Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 14.166V12.4993H9.16675V10.8327H8.33342V9.16602H10.0001C10.4603 9.16602 10.8334 9.53911 10.8334 9.99935V12.4993H12.0834V14.166H7.91675Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3327C5.39771 18.3327 1.66675 14.6017 1.66675 9.99935C1.66675 5.39698 5.39771 1.66602 10.0001 1.66602C14.6025 1.66602 18.3334 5.39698 18.3334 9.99935C18.3334 14.6017 14.6025 18.3327 10.0001 18.3327ZM10.0001 16.666C13.682 16.666 16.6667 13.6812 16.6667 9.99935C16.6667 6.31745 13.682 3.33268 10.0001 3.33268C6.31818 3.33268 3.33341 6.31745 3.33341 9.99935C3.33341 13.6812 6.31818 16.666 10.0001 16.666Z",
    fill: "#A4A4A4"
  })));
};
export { SvgAbout as ReactComponent };
export default __webpack_public_path__ + "assets/68c1d7ca.svg";